// Copyright 2017 Sorama B.V.

import { DOM, bindable, customAttribute, inject } from "aurelia-framework";
import { Router } from "aurelia-router";

@customAttribute("go-to-route")
@inject(DOM.Element, Router)
export class GoToRoute {
    @bindable route: string;

    private element: HTMLElement;
    private router: Router;

    constructor(element: HTMLElement, router: Router) {
        this.element = element;
        this.router = router;
    }

    attached() {
        this.element.addEventListener("click", () => {
            this.router.navigate(this.route);
        });
    }
}
